import { formOptions, gen } from '../../views/utils'

export default {
  auto: '*',
  getCheck: 'email',
  store: {
    state: {
      name: 'USERS',
      signupFields: {},
    },
    getters: {
      genUser: gen(() => ({
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        roles: ['USR'],
      })),

      genWorker: (state, getters) => getters.genUser,

      workers: (_, getters) => getters.users,
      workersOptions: formOptions({
        value: ({ firstName, lastName }) => `${firstName} ${lastName}`
      }),

      signupFields: state => state.signupFields,
    },
    actions: {
      SET_SIGNUP_FIELDS({ state }, fields) {
        state.signupFields = fields
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js